import { render, staticRenderFns } from "./HistoriaE.vue?vue&type=template&id=5bef4bc7"
import script from "./HistoriaE.vue?vue&type=script&lang=js"
export * from "./HistoriaE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports